<template>
  <tsl-card class="charts" :cardList="cardList">
    <template v-slot:overview>
      <div id="backup-statistics"></div>
    </template>
    <template v-slot:topRight>
      <a-range-picker class="data-picker" />
      <chart-date-tabs :data="dateData"></chart-date-tabs>
    </template>
  </tsl-card>
</template>

<script>
import Card from "@/components/tsl-card/index.vue";
import Chart from "@/components/charts";
import Tabs from "@/components/chart-date-tabs/index.vue";
import { Select, DatePicker } from "ant-design-vue";
import { onMounted, onUnmounted, reactive, ref } from "vue";
const RangePicker = DatePicker.RangePicker;
export default {
  name: "backup-statistics",
  components: {
    [Card.name]: Card,
    [Tabs.name]: Tabs,
    [RangePicker.name]: RangePicker,
    [Select.name]: Select
  },
  setup() {
    const dateData = ref(["今日", "近七天", "近30天"]);
    const cardList = reactive([
      {
        name: "overview",
        title: "备份统计",
        topRight: "topRight"
      }
    ]);

    const echart = ref({});
    const chartData = {
      dimensions: ["time", "文件数量", "文件大小"],
      source: {
        time: ["", "1/1", "1/2", "1/3", "1/4", "1/5", "1/6", "1/7", " "],
        文件数量: [200, 260, 460, 400, 620, 400, 220, 600, 300],
        文件大小: ["", 35, 58, 40, 18, 36, 23, 56, ""]
      }
    };

    onMounted(() => {
      echart.value = Chart.setBarBackip(chartData, "backup-statistics");
    });

    onUnmounted(() => {
      echart.value.remove();
    });
    return {
      dateData,
      cardList
    };
  }
};
</script>

<style lang="less" scoped>
.charts {
  height: 426px !important;
}
:deep(.rcon) {
  display: flex;
  .data-picker {
    margin: 0 16px;
  }
}
#backup-statistics {
  width: 100%;
  height: 326px;
}
</style>
